import { BaseContainerModel } from '../base-container.model';
import { bl_hc_patient_consultation_hdr_RowClass, bl_hc_patient_consultation_hdr_RowInterface } from '../../dbschema/bl_hc_patient_consultation_hdr.model';


export class HcPatientConsultationHdrContainerModel extends BaseContainerModel {
  bl_hc_patient_consultation_hdr: bl_hc_patient_consultation_hdr_RowInterface = new bl_hc_patient_consultation_hdr_RowClass();
}